import { Redirect, Stack, useLocalSearchParams } from 'expo-router';
import { observer } from 'mobx-react-lite';

import { safeInternalPath } from '@/lib/safeInternalPath';
import { authStore } from '@/stores/auth.store';

const AuthLayout = observer(() => {
  // When verifyPin flips isAuthenticated, this Redirect races verify's
  // own router.replace — honor the same `redirect` param so whichever
  // wins, the user lands on the deep link they originally requested.
  const params = useLocalSearchParams<{ redirect?: string }>();

  if (authStore.isAuthenticated) {
    return <Redirect href={safeInternalPath(params.redirect)} />;
  }
  return <Stack screenOptions={{ headerShown: false }} />;
});

export default AuthLayout;
